export default __webpack_public_path__ + "static/media/LENS_CULINARIS_OGRE_fragment_2.854bf490.jpg";